import React, { useState, useEffect } from 'react';

import { Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import EditCategoryForm from './EditCategoryForm';
import QualityObservationService from '../../services/quality-observation.service';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      margin: '16px',
      maxWidth: '500px',
      overflow: 'visible',
      width: '100%',
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '36px 24px',
  },
}));

const EditCategoryModal = ({ open, onClose, observation, onUpdate }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [defaultData, setDefaultData] = useState({
    category: observation?.category || '',
    subcategory: observation?.subcategory || '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (observation) {
      setDefaultData({
        category: observation.category || '',
        subcategory: observation.subcategory || '',
      });
    }
  }, [observation]);

  const updateCategory = async (categoryData) => {
    try {
      setIsSubmitting(true);

      const updateData = {
        category: categoryData.category || null,
        subcategory: categoryData.subcategory || null,
      };

      await QualityObservationService.update(observation.id, updateData);

      if (onUpdate) {
        onUpdate({
          ...observation,
          ...updateData,
        });
      }

      enqueueSnackbar('Category updated successfully', { variant: 'success' });

      return true;
    } catch (error) {
      console.error('Error updating category:', error);
      enqueueSnackbar('Failed to update category', { variant: 'error' });
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  const onSaveCategory = async (formData) => {
    try {
      await updateCategory(formData);
      onClose();
    } catch (error) {
      // Error already handled in updateCategory
    }
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <div className={classes.modalContent}>
        <EditCategoryForm onSaveCategory={onSaveCategory} defaultData={defaultData} isSubmitting={isSubmitting} onCancel={onClose} />
      </div>
    </Dialog>
  );
};

export default EditCategoryModal;
